// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { getNumOfDaysBetweenDates } = require('utilities/dateHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const { CONTRIBUTION_PERIOD_MONTHLY } = require('../raConstants/index');

const resetExpectedProfitability = () => ({
    type: actionTypes.RA_EXPECTED_PROFITABILITY_RESET,
});

const setDaysDiffrence = goalDate => {
    return {
        type: actionTypes.RA_EXPECTED_PROFITABILITY_SET_DAYS_DIFF,
        payload: {
            goalDate,
        },
    };
};

const changeYears = years => ({
    type: actionTypes.RA_EXPECTED_PROFITABILITY_CHANGE_YEARS,
    payload: { years },
});

const requestProjectionChartInProgress = () => ({
    type: actionTypes.RA_EXPECTED_PROFITABILITY_CHART_REQUEST,
});

const successProjectionChart = (data, dataPoints, product) => ({
    type: actionTypes.RA_EXPECTED_PROFITABILITY_CHART_SUCCESS,
    payload: { data, dataPoints, product },
});

const failureProjectionChart = data => ({
    type: actionTypes.RA_EXPECTED_PROFITABILITY_CHART_FAILURE,
    payload: { data },
});

//TODO: Refactor: https://jira.globant.com/browse/OBK433-28064
const requestProjectionChart = ({
    dataPoints,
    product,
    balance,
    freq = 1,
    mntPayment = 0,
    chartYears = null,
    portfolioId,
    cutDay = 0,
}) => (dispatch, getState) => {
    const { raExpectedProfitability, raManagementPlan } = getState();
    let years;

    if (chartYears === 0) {
        const objectiveEndDate = getState().raCustomPlanByObjective.get(
            'objectiveEndDate',
        );
        const nDays = Math.abs(getNumOfDaysBetweenDates(objectiveEndDate));
        years = nDays / 365;
    } else {
        years =
            chartYears ||
            raExpectedProfitability.get('yearDiff') ||
            raExpectedProfitability.get('chartYears');
    }

    const noOfChartPoints = raExpectedProfitability.get('noOfChartPoints');
    const dp = dataPoints === 2 ? dataPoints : noOfChartPoints;
    let recurringContributionAmount =
        mntPayment || raManagementPlan.get('recurringContributionAmount');
    const recurringContributionDay = raManagementPlan.get(
        'recurringContributionDay',
    );
    const hasPeriodicity = recurringContributionAmount > 0;
    let periodicity = !hasPeriodicity
        ? 1
        : freq !== 1
        ? freq
        : raManagementPlan.get('periodicity');
    let cutDayValue =
        periodicity === CONTRIBUTION_PERIOD_MONTHLY
            ? cutDay === 0
                ? recurringContributionDay
                : cutDay
            : 1;

    const params = {
        dataPoints: dp,
        years,
        freq: periodicity,
        mntPayment: recurringContributionAmount,
        balance:
            balance != null
                ? balance
                : raManagementPlan.get('initialContributionAmount'),
        product:
            product != null
                ? product
                : raManagementPlan.get('investProfileValue'),
        portfolioId:
            portfolioId != null
                ? portfolioId
                : raManagementPlan.get('portfolioId'),
    };
    const requestData = {
        query: {
            cutDay: cutDayValue,
        },
    };
    const endpoint =
        portfolioId != null
            ? 'raObjectiveTrackingProjectionChart'
            : 'raProjectionChartSimulation';

    dispatch(requestProjectionChartInProgress());

    return APIGet(dispatch, apiURLBuilder.getURL(endpoint, params), requestData)
        .then(response =>
            dispatch(successProjectionChart(response, dp, params.product)),
        )
        .catch(error => {
            if (error.error) {
                dispatch(
                    failureProjectionChart(error.error.description, params),
                );
            } else {
                throw error;
            }
        });
};

const requestCurrentProjectionChartInProgress = () => ({
    type: actionTypes.RA_CURRENT_PROJECTION_CHART_REQUEST,
});

const successCurrentProjectionChart = data => ({
    type: actionTypes.RA_CURRENT_PROJECTION_CHART_SUCCESS,
    payload: { data },
});

const failureCurrentProjectionChart = data => ({
    type: actionTypes.RA_CURRENT_PROJECTION_CHART_FAILURE,
    payload: { data },
});

//TODO: Refactor: https://jira.globant.com/browse/OBK433-28064
const requestCurrentProjectionChart = ({
    dataPoints,
    portfolioId,
    chartYears = null,
}) => (dispatch, getState) => {
    const { raGlobalPosition, raExpectedProfitability } = getState();
    const contributionAmount =
        raGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'recurringTransfers',
            'amount',
        ]) || 0;
    const frequency =
        raGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'recurringTransfers',
            'recurringCode',
        ]) || 1;
    const years =
        chartYears ||
        raExpectedProfitability.get('yearDiff') ||
        raExpectedProfitability.get('chartYears');
    const noOfChartPoints = raExpectedProfitability.get('noOfChartPoints');
    const dp = dataPoints === 2 ? dataPoints : noOfChartPoints;
    const params = {
        dataPoints: dp,
        years: years,
        mntPayment: contributionAmount,
        freq: frequency,
        portfolioId,
    };

    dispatch(requestCurrentProjectionChartInProgress());

    return APIGet(
        dispatch,
        apiURLBuilder.getURL('raObjectiveTrackingProjectionChart', params),
    )
        .then(response => {
            dispatch(successCurrentProjectionChart(response));
        })
        .catch(error => {
            if (error.error) {
                dispatch(
                    failureCurrentProjectionChart(error.error.description),
                );
            } else {
                throw error;
            }
        });
};

module.exports = {
    changeYears,
    requestCurrentProjectionChart,
    requestProjectionChart,
    setDaysDiffrence,
    resetExpectedProfitability,
};
